"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSwitch = exports.Checkbox = exports.Switch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Antd = __importStar(require("antd"));
var buttons_1 = require("./buttons");
function Switch(_a) {
    var binding = _a.binding, disabled = _a.disabled;
    return (0, jsx_runtime_1.jsx)(Antd.Switch, { disabled: disabled, checked: binding.value, onClick: function (value) { return binding.update(value); } });
}
exports.Switch = Switch;
function Checkbox(_a) {
    var binding = _a.binding;
    return (0, jsx_runtime_1.jsx)(Antd.Checkbox, { checked: binding.value, onChange: function (evt) { return binding.update(evt.target.checked); } });
}
exports.Checkbox = Checkbox;
function IconSwitch(props) {
    var icon = props.binding.value ? props.enabledIcon : props.disabledIcon;
    return (0, jsx_runtime_1.jsx)(buttons_1.IconButton, { size: props.size, icon: icon, onClick: function () { return props.binding.update(!props.binding.value); }, style: props.style });
}
exports.IconSwitch = IconSwitch;
